import { enforce, test } from "vest";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";
import { trans } from "@/service/i18n/i18n";

export function createRadioFieldValidationSuite(
  definition: RadioField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue);

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(![null, undefined].includes(value)).isTruthy();
    });
  }
}
